import ZDPage from "~/pages/ZD";
import { ZD_SELECT_BY_PERMISSIONS } from "~/pages/Editor/EditorServiceAuthorization/options";
import React, { useMemo, useState } from "react";
import { useGetLocationData } from "~/hooks/locationData";
import { usePermissions } from "~/shared/context/PermissionContext";
import { useTranslation } from "react-i18next";
import type { PermissionKey } from "~/types/Permissions";

const ZDPageHOC = () => {
  const { t } = useTranslation();
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const { fullname } = useGetLocationData();
  const getterStrLower =
    fullname && fullname[0].toLowerCase() + fullname.substr(1);

  const hasCommonGet = hasPermission("zd.common.get");

  const allowedPaths = useMemo(() => {
    if (hasCommonGet) {
      return Object.keys(ZD_SELECT_BY_PERMISSIONS);
    }

    return Object.entries(ZD_SELECT_BY_PERMISSIONS)
      .filter(([path, editPermission]) => {
        const checkPermission = editPermission.replace("Edit", "Check");

        return hasPermission(editPermission as PermissionKey) || hasPermission(checkPermission as PermissionKey);
      })
      .map(([path]) => path);
  }, [hasPermission, hasCommonGet]);

  const defaultEditorSelect = useMemo(() => {
    if (allowedPaths.length) {
      const value =
        getterStrLower && allowedPaths.includes(getterStrLower)
          ? getterStrLower
          : allowedPaths[0];

      return {
        label: ` ${t(`editorZD.forSelect.${value}`)}`,
        value,
      };
    }

    return {
      label: ` ${t(`editorZD.forSelect.services`)}`,
      value: "services",
    };
  }, [allowedPaths, getterStrLower, t]);

  return (
    <ZDPage
      defaultEditorSelect={defaultEditorSelect}
      allowedPaths={allowedPaths}
    />
  );
};

export default ZDPageHOC;
